import React, { Fragment } from "react";
import BulkActionApproveButton from "./BulkActionApproveButton";
import BulkActionRejectButton from "./BulkActionRejectButton";
import ApproveAllButton from "./ApproveAllButton";
import { useListContext } from "react-admin";
import { filter } from "lodash";
import BulkActionMergePdfButton from "./BulkActionMergePdfButton";
import MergeAllPdfButton from "./MergeAllPdfButton";

const BulkConfirmButton = (props: any) => {
  const { data, selectedIds, filterValues } = useListContext();
  const filteredData = filter(data, (item) => selectedIds.includes(item.id));

  return (
    <Fragment>
      {filteredData.length > 1 && (
        <BulkActionMergePdfButton filteredData={filteredData} {...props} />
      )}
      <MergeAllPdfButton
        statusIn={filterValues.StatusIn}
        subcontractorPurchaseInvoiceSummaryId={
          filterValues.SubcontractorPurchaseInvoiceSummaryId
        }
        {...props}
      />

      {props.isDraft && (
        <Fragment>
          <BulkActionApproveButton {...props} />
          <BulkActionRejectButton {...props} />
          <ApproveAllButton
            subcontractorPurchaseInvoiceSummaryId={
              filterValues.SubcontractorPurchaseInvoiceSummaryId
            }
          />
        </Fragment>
      )}
    </Fragment>
  );
};

export default BulkConfirmButton;
